import { Avatar, Chip, TableCell, TableRow, Typography, Checkbox, useMediaQuery } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { convertDateYearString } from "../../../util/convertDate";
import { createSlug } from "../../../util/createSlug";
import { useStyles } from "../styles/TabelaAtletas";

export default function TabelaAtletas(props) {
    const classes = useStyles();
    const {
        atletas,
        page,
    } = props

    const matchesSM = useMediaQuery(theme => theme.breakpoints.up('sm'));

    const isSelected = (name) => selected.indexOf(name) !== -1;


    const [selected, setSelected] = React.useState([]);

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const errorMessage = () => {
        return (
            <div>
                <Alert severity="error">
                    Nenhum Atleta encontrado para os filtros selecionados.
                </Alert>
            </div>
        )
    }

    return (
        <React.Fragment>
            {atletas.error ?
                <TableRow>
                    <TableCell colSpan={5}>
                        {errorMessage()}
                    </TableCell>
                </TableRow>
                :
                atletas.payload.map((row, index) => {
                    const isItemSelected = isSelected(row.atleta.nome_completo);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    let nomeCompleto = row.atleta.nome_completo ? row.atleta.nome_completo.split(' ') : '';
                    let sobrenome = row.atleta.nome_completo ? row.atleta.nome_completo.split(' ').slice(1).join(' ') : ''

                    return (
                        <TableRow
                            hover
                            className={clsx(classes.TableRow, { [classes.TableRowSelected]: isItemSelected })}
                            onClick={(event) => handleClick(event, row.atleta.nome_completo)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.atleta.nome_completo}
                            selected={isItemSelected}
                        >
                            <TableCell padding="checkbox" className={classes.CheckboxCell}>
                                <Checkbox
                                    checked={isItemSelected}
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </TableCell>
                            <TableCell style={isItemSelected ? { display: 'none' } : { borderRadius: '20px 0px 0px 20px' }}>
                                {page === 1 ? index + 1 : ((20 * (page - 1)) + index + 1)}
                            </TableCell>
                            <TableCell colSpan={isItemSelected ? 2 : 1} className={isItemSelected ? classes.CellAvatarSelected : ''}>
                                <div className={classes.AvatarWapper}>
                                    <div className={clsx(classes.AvatarBorder, { [classes.AvatarBorderSelected]: isItemSelected })}>
                                        <Typography className={isItemSelected ? classes.posicaoAtleta : classes.posicaoAtletaHidden}>
                                            {index + 1}
                                        </Typography>
                                        <Avatar
                                            src={`https://saltosbrasil.bigmidia.com/_uploads/fotoAtleta/${row.atleta.foto}`}
                                            className={clsx(classes.Avatar, { [classes.AvatarSelected]: isItemSelected && matchesSM })} />
                                    </div>
                                    <div>
                                        <Typography variant="body1" className={clsx(classes.Nome, { [classes.NomeSelected]: isItemSelected })}>
                                            {nomeCompleto[0]}
                                        </Typography>
                                        <Typography variant="body1" className={clsx(classes.Sobrenome, { [classes.SobrenomeSelected]: isItemSelected })}>
                                            {sobrenome}
                                        </Typography>
                                    </div>
                                </div>

                                {isItemSelected && !matchesSM ?
                                    <div className={classes.infoAtletaWrapper}>
                                        <div className={classes.AvatarWapper}>
                                            <Avatar className={classes.AvatarClube} src={`https://saltosbrasil.bigmidia.com/_uploads/estabelecimento/logo/${row.atleta.estabelecimento.url_logo}`} />
                                            {row.atleta.estabelecimento ? row.atleta.estabelecimento.descricao : ""}
                                        </div>
                                        <Link to={`/atleta/${row.id_atleta}/${createSlug(row.atleta.nome_completo)}`} className={classes.linkPerfil}> VER PERFIL COMPLETO</Link>
                                    </div>
                                    :
                                    ''
                                }

                            </TableCell>

                            {!isItemSelected && matchesSM ?
                                <TableCell>
                                    <div className={classes.AvatarWapper}>
                                        <Avatar className={classes.AvatarClube} src={`https://saltosbrasil.bigmidia.com/_uploads/estabelecimento/logo/${row.atleta.estabelecimento.url_logo}`} />
                                        {row.atleta.estabelecimento ? row.atleta.estabelecimento.descricao : ""}
                                    </div>
                                </TableCell>
                                :
                                ''
                            }

                            {isItemSelected && matchesSM ?
                                <TableCell>
                                    <Typography className={classes.titleInfoAtleta}>
                                        Idade. <span className={classes.infoAtleta}>
                                            {convertDateYearString(row.atleta.data_nascimento)}
                                        </span>
                                    </Typography>
                                    <Typography className={classes.titleInfoAtleta}>
                                        Categoria: <span className={classes.categoria}>{row.classe[0] ? row.classe[0].sigla : ''}</span>
                                    </Typography>
                                    {!matchesSM ? '' :
                                        <div className={classes.AvatarWapper}>
                                            <Avatar className={classes.AvatarClube} src={`https://saltosbrasil.bigmidia.com/_uploads/estabelecimento/logo/${row.atleta.estabelecimento.url_logo}`} />
                                            {row.atleta.estabelecimento ? row.atleta.estabelecimento.descricao : ""}
                                        </div>
                                    }
                                </TableCell>
                                :
                                ''
                            }
                            <TableCell style={isItemSelected && !matchesSM ? { display: 'none' } : { display: 'table-cell' }}>
                                {row.atleta.estabelecimento ? row.atleta.estabelecimento.uf : ""}
                            </TableCell>

                            <TableCell colSpan={isItemSelected && !matchesSM ? 2 : 1} className={classes.tableCellClassificacao}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Chip className={classes.tableChip} label={row.classe[0] ? row.classe[0].sigla : ''} />
                                    {isItemSelected && matchesSM ?
                                        <Link to={`/atleta/${row.id_atleta}/${createSlug(row.atleta.nome_completo)}`} className={classes.linkPerfil}> VER PERFIL COMPLETO</Link>
                                        :
                                        ''
                                    }
                                </div>
                                {isItemSelected && !matchesSM ?
                                    <div className={classes.infoAtletaWrapper}>
                                        <Typography className={classes.titleInfoAtleta}>
                                            UF: <span className={classes.infoAtleta}>
                                                {row.atleta.estabelecimento ? row.atleta.estabelecimento.uf : ""}
                                            </span>
                                        </Typography>

                                        <Typography className={classes.titleInfoAtleta}>
                                            Nasc. <span className={classes.infoAtleta}>
                                                {convertDateYearString(row.atleta.data_nascimento)}
                                            </span>
                                        </Typography>
                                        <Typography className={classes.titleInfoAtleta}>
                                            Categoria: <span className={classes.categoria}>{row.classe[0] ? row.classe[0].sigla : ''}</span>
                                        </Typography>
                                        {!matchesSM ? '' :
                                            <div className={classes.AvatarWapper}>
                                                <Avatar className={classes.AvatarClube} src={`https://saltosbrasil.bigmidia.com/_uploads/estabelecimento/logo/${row.atleta.estabelecimento.url_logo}`} />
                                                {row.atleta.estabelecimento ? row.atleta.estabelecimento.descricao : ""}
                                            </div>
                                        }
                                    </div>
                                    :
                                    ''
                                }
                            </TableCell>
                        </TableRow>
                    )
                })}
        </React.Fragment>
    )
}